import CryptoJS from "crypto-js";

// A secret key to use for encryption and decryption (keep it safe, preferably from environment variables)
const SECRET_KEY = "test-key"; // Example, use something more secure in production

// Function to encrypt the access token and store it in localStorage
export const encryptAndStoreToken = (token: string) => {
  // Encrypt the token using the secret key
  const encryptedToken = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();

  // Store the encrypted token in localStorage
  localStorage.setItem("access_token", encryptedToken);
};

// Function to decrypt the access token from localStorage
export const decryptToken = () => {
  // Get the encrypted token from localStorage
  const encryptedToken = localStorage.getItem("access_token");

  if (encryptedToken) {
    // Decrypt the token using the secret key
    const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    // Return the decrypted token if successful, or null if the decryption failed
    return decryptedToken || null;
  }

  return null;
};
